export class RefSituation {
    id: number;
    code: string;
    libelle: string;
}
